var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.90625 10.5508C0.90625 5.02793 5.3834 0.550781 10.9062 0.550781H33.7148C39.2377 0.550781 43.7148 5.02793 43.7148 10.5508V33.3594C43.7148 38.8822 39.2377 43.3594 33.7148 43.3594H10.9062C5.3834 43.3594 0.90625 38.8822 0.90625 33.3594V10.5508Z",
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3311 29.0826C13.5078 30.1503 14.4354 30.9645 15.5532 30.9645H29.0675C30.3115 30.9645 31.3199 29.956 31.3199 28.7121V24.4214M13.3311 29.0826C13.3112 28.9621 13.3008 28.8383 13.3008 28.7121V15.1977C13.3008 13.9537 14.3092 12.9453 15.5532 12.9453H29.0675C30.3115 12.9453 31.3199 13.9537 31.3199 15.1977V24.4214M13.3311 29.0826L17.634 24.7798C18.3998 24.1097 19.5199 24.0363 20.3666 24.6008L20.94 24.983C21.7561 25.5271 22.8305 25.4805 23.5964 24.8677L26.5788 22.4819C27.3389 21.8737 28.3977 21.826 29.2059 22.3473C29.2954 22.4051 29.3751 22.4766 29.4505 22.552L31.3199 24.4214M21.1842 18.5763C21.1842 19.8203 20.1757 20.8287 18.9318 20.8287C17.6878 20.8287 16.6794 19.8203 16.6794 18.5763C16.6794 17.3323 17.6878 16.3239 18.9318 16.3239C20.1757 16.3239 21.1842 17.3323 21.1842 18.5763Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.6872ca0540567745cac1d5ef69eb067d.svg";
export { ForwardRef as ReactComponent };